
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import TextBox from './../../zviz2/zviz/components/textbox';
import {extend} from './../../zviz2/zviz/functions';
import SimpleEvent from './../../zviz2/zviz/event';
import config from './../../config';
import {styleText} from './../../styles';
import {scrollY, scrollX} from './../../tools';


class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.shown = false;
        this.text = '';
        this.event = null;
        this.mousePos = [0,0];
        this.textAlign = 'left';

        this.canvas = null;

    }

    init(renderer){
        this.canvas = renderer.rootController.renderOutput.result;
        
        super.init(renderer);

        this.event = null; // init() removes the event
        this.shown = false;
    }

    render(renderer){
        super.render(renderer);
        if(this.shown){
            this.update();
        }
    }

    showTooltip(){
        this.text = state.get('tooltip');

        if(! this.text){
            this.hideTooltip();
        }else{
            if(! (this.text instanceof Array)){
                this.text = [this.text];
            }
            this.shown = true;
            this.event = new SimpleEvent(document, 'mousemove', [this, this.positionTooltip]);
            this.addEvent(this.event);
            this.update();
        }
    }

    hideTooltip(){
        if(this.event){
            this.removeEvent(this.event);
            this.event = false;
            this.shown = false;
        }
        this.update();
    }

    positionTooltip(event){
        this.mousePos = [event.pageX, event.pageY];
        this.update();
    }

    getTop(){

        let offset = 0;
        let sT = scrollY();
        if(this.canvas){
            offset = this.canvas.getBoundingClientRect().top;
        }
        let height = this.renderOutput.result.clientHeight;

        return Math.max(0, this.mousePos[1] - sT - offset - 0.5*height);
    }

    getTextAlign(){
        let margin = (state.get('windowSize.width')<700)? 150: 350;
        if(this.mousePos[0] > (window.innerWidth - margin) ){
            this.textAlign = 'right';
        }else{
            this.textAlign = 'left';
        }

        return this.textAlign;
    }

    getLeft(){

        let offset = 0;
        let margin = (state.get('windowSize.width')<700)? 150: 350;
        if(this.mousePos[0] > (window.innerWidth - margin) ){
            return 'auto'; //this.mousePos[0] - (margin-25);
        }else{
            if(this.canvas){
                offset = this.canvas.getBoundingClientRect().left;
            }
             let sL = scrollX();
            return (this.mousePos[0] + 25 - sL - offset) + 'px';
        }
    }

    getRight(){
        let margin = (state.get('windowSize.width')<700)? 150: 350;
        let offset = window.innerWidth;
        if(this.mousePos[0] > (window.innerWidth - margin) ){
            if(this.canvas){
                offset = this.canvas.getBoundingClientRect().right;
            }
            let sL = scrollX();
            return (offset - this.mousePos[0] + 25 + sL ) + 'px';
        }else{
            return 'auto'
        }
    }

    getChildren(){
        if(! this.shown){
            return [];
        }
        let result = [];
        let i = 0;

        result.push(extend({
            properties: {
                data: { textAlign: this.textAlign }
            }
        }, BlueprintArrow1));
        result.push(extend({
            properties: {
                data: { textAlign: this.textAlign }
            }
        }, BlueprintArrow2));

        if(this.text.length>1){
            let style = 'normal';
            let text = this.text[0];
            if(text.substring(0,1) == '*'){
                style = 'large';
                text = text.substring(1);
            }
            result.push(extend({
                properties: {
                    data: {
                        text: text,
                        style: style,
                        textAlign: this.textAlign
                    }
                }
            }, BlueprintLine1));
            i++;
        }
        result.push(extend({
            properties: {
                data: {
                    text: this.text[i],
                    textAlign: this.textAlign
                }
            }
        }, BlueprintLine2));


        return result;
    }


}


let Blueprint = {
    type: Controller,
    properties: {
        style: { 
            position: 'absolute',
            display: (ctrl) => ( ctrl.shown? 'block': 'none'),
            backgroundColor: 'rgb(255,255,255)',
            padding: '3px 10px',
            border: '1px solid #999',
            textAlign: (ctrl) => ( ctrl.getTextAlign() ),
            top: (ctrl) => ( ctrl.getTop() + 'px' ),
            left: (ctrl) => ( ctrl.getLeft() ),
            right: (ctrl) => ( ctrl.getRight() ),
            maxWidth: '320px',
            zIndex: 5
         }
    },
    children: [
        (ctrl) => (ctrl.getChildren())
    ],
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.showTooltip], 'tooltip')),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.hideTooltip], 'filter')),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.hideTooltip], 'page')),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.hideTooltip], 'project'))
    ]
};

let BlueprintLine1 = extend({
    properties: {
        data: {
            text: '',
            textAlign: 'left',
            style: 'large'
        },
        style: extend({ 
            display: 'block',
            textAlign: (ctrl) => ( ctrl.data.textAlign ),
            fontSize: (ctrl) => ( ctrl.data.style == 'large'? '12pt': '9pt' ),
            fontWeight: (ctrl) => ( ctrl.data.style == 'large'? 'bold': 'normal' ),
            color: (ctrl) => ( ctrl.data.style == 'large'? '#000000': '#757575' )
         }, styleText),
         content: (ctrl) => ( ctrl.data.text ),
    },
}, TextBox);

let BlueprintLine2 = extend({
    properties: {
        data: {
            text: '',
            textAlign: 'left'
        },
        style: extend({ 
            display: 'block',
            textAlign: (ctrl) => ( ctrl.data.textAlign ),
            color: 'black',
            whiteSpace: 'pre-wrap'
         }, styleText),
         content: (ctrl) => ( ctrl.data.text ),
    },
}, TextBox);

let BlueprintArrow1 = extend({
    properties: {
        style: { 
            left: (ctrl) => ( (ctrl.data.textAlign=='right')? '100%': 'auto'),
            right: (ctrl) => ( (ctrl.data.textAlign=='left')? '100%': 'auto'),
            top: '50%',
            border: 'solid transparent',
            height: '0px',
            width: '0px',
            position: 'absolute',
            borderColor: 'transparent',
            borderLeftColor: (ctrl) => ( (ctrl.data.textAlign=='left')? 'transparent':  '#999'),
            borderRightColor: (ctrl) => ( (ctrl.data.textAlign=='right')? 'transparent':  '#999'),
            borderWidth: '10px',
            marginTop: '-10px'
         },
    }
}, Group);

let BlueprintArrow2 = extend({
    properties: {
        style: { 
            left: (ctrl) => ( (ctrl.data.textAlign=='right')? '100%': 'auto'),
            right: (ctrl) => ( (ctrl.data.textAlign=='left')? '100%': 'auto'),
            top: '50%',
            border: 'solid transparent',
            height: '0px',
            width: '0px',
            position: 'absolute',
            borderColor: 'transparent',
            borderLeftColor: (ctrl) => ( (ctrl.data.textAlign=='left')? 'transparent':  'white'),
            borderRightColor: (ctrl) => ( (ctrl.data.textAlign=='right')? 'transparent':  'white'),
            borderWidth: '8px',
            marginTop: '-8px'
         },
    }
}, Group);


export default Blueprint;
export {Controller};
